module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "overflow-y": "scroll",
      "height": "100vh",
      "padding-left": "20px"
    }
  }, [_c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Go Back\n  ")]), _vm._v(" "), _c('h1', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v(_vm._s(_vm.district.name))]), _vm._v(" "), _c('div', {
    staticClass: "mv4"
  }, [_c('div', {
    staticClass: "pl-headline"
  }, [_vm._v("Membership Details")]), _vm._v(" "), _c('h2', [_vm._v("Memberships")]), _vm._v(" "), _c('ul', _vm._l((_vm.district.district_memberships), function(membership) {
    return _c('li', {
      staticClass: "pl-subheading"
    }, [_c('strong', [_vm._v("Expiry Date")]), _vm._v(": " + _vm._s(membership.end_date_readable) + "\n        "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Date Started")]), _vm._v(": " + _vm._s(membership.start_date_readable) + "\n      ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "pl-title"
  }, [_vm._v("Create new membership")]), _vm._v(" "), _c('div', {
    staticClass: "pl-subheading"
  }, [_vm._v("\n      NOTE: creating a district membership creates one for all teachers in\n      that district\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "pl-subheading"
  }, [_vm._v("\n      If possible, please perform this action after school hours\n    ")]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Choose Membership Duration")]), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "start"
    }
  }, [_vm._v("Start Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.start_date),
      expression: "start_date"
    }],
    attrs: {
      "type": "date",
      "id": "start",
      "name": "membership-selection",
      "required": ""
    },
    domProps: {
      "value": (_vm.start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "end"
    }
  }, [_vm._v("End Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.end_date),
      expression: "end_date"
    }],
    attrs: {
      "type": "date",
      "id": "end",
      "name": "membership-selection",
      "required": ""
    },
    domProps: {
      "value": (_vm.end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.end_date = $event.target.value
      }
    }
  })])]), _vm._v(" "), (!_vm.creating_district_membership) ? _c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.createNewDistrictMembership.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      Create New\n    ")]) : _c('pl-spinner')], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-headline"
  }, [_vm._v("\n    " + _vm._s(_vm.district.schools.length) + " schools -\n    "), _c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        _vm.expand_schools = !_vm.expand_schools
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.expand_schools ? 'Hide' : 'Show') + "\n    ")])], 1), _vm._v(" "), (_vm.expand_schools) ? _c('ul', {
    staticClass: "pl-title"
  }, _vm._l((_vm.district.schools), function(school, index) {
    return _c('li', {
      staticClass: "clickable",
      on: {
        "click": function($event) {
          return _vm.selectSchool(school)
        }
      }
    }, [_vm._v("\n      " + _vm._s(school.name) + "\n    ")])
  }), 0) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-a849215c!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/viewIndividualDistrict.vue
// module id = 1993
// module chunks = 61